import type { FormProps, SanityMultiForm } from '#/lib/sanity/queries/form';
import { cn } from '#/lib/utils';
import { BasicText } from '#/components/BasicText';

import { MultiStepForm } from '../Multi';
import { addBusinessEmailValidation } from '../utils';
import { FormConfirmation } from './Confirmation';
import { FormErrorMessage } from './ErrorMessage';

export function FormCustomMultiStep(props: FormProps<SanityMultiForm>) {
  const formFieldsSchema = addBusinessEmailValidation(props.form);

  return (
    <div className={cn('relative', props.className)}>
      <MultiStepForm
        formTitle={props.form.formTitle}
        fieldGroups={props.form.fieldGroups}
        hubspotCampaignId={props.form.hubspotCampaignId}
        hubspotConvertingFormType={props.form.hubspotConvertingFormType}
        contentPieceTitle={props.form.contentPieceTitle}
        hubspotEmailSubscriptionIds={props.form.hubspotEmailSubscriptionIds}
        chiliPiperRouterId={props.form.chiliPiperRouterId}
        formFieldsSchema={formFieldsSchema}
        trackingEventName={props.form.trackingEventName}
        trackingEventProperties={props.form.trackingEventProperties}
        submitButtonLabel={props.form.submitButtonLabel}
        theme={props.theme}
        onSubmitSuccess={props.onSubmitSuccess}
        onSubmitError={props.onSubmitError}
        ConfirmationComponent={() => (
          <FormConfirmation
            confirmation={props.confirmation}
            theme={props.buttonTheme ?? props.theme}
          />
        )}
      >
        {({ formState }) => {
          return (
            <>
              <FormErrorMessage
                className="col-span-full"
                formState={formState}
              />

              {props.form.legalText && props.form.legalText.length > 0 ? (
                <BasicText
                  className={cn(
                    'legal-text col-span-full mt-10 font-light text-grayscale-05',
                    props.theme === 'dark' && 'text-grayscale-03',
                  )}
                  value={props.form.legalText}
                />
              ) : null}
            </>
          );
        }}
      </MultiStepForm>
    </div>
  );
}
